// File path: src/api/Endpoints/BatchLogs.js
import { get } from "./../Config/config";

export const BatchLogsAPI = {
  getBatchLogs: (data) => get("/whatsapp/beta/message/batch-log", { params: data }),
  getBulkMessage:(data)=>get("/whatsapp/beta/message/latest-batch",{params:data})
};